var map = {
	"./andreas_szamosvari.png": 1254,
	"./claus_brandt.jpg": 1255,
	"./ksenia_berneder.jpg": 1256,
	"./stephanie_gritzner.png": 1257,
	"./tatjana_bieker.png": 1258
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1444;